/**
 * The ten chapters of "How it works", in order. Chapters without an
 * Illustration yet render an honest placeholder (later parts of this phase).
 * For Media Devoted | Created By Ciro Autiero
 */
import { DAY_CHAPTERS } from './chapters/day/day-chapters';
import { SETUP_CHAPTERS } from './chapters/setup/setup-chapters';
import type { TutorialChapterDef } from './chapter.types';

export type { ChapterBridge, TutorialChapterDef } from './chapter.types';

export const TUTORIAL_CHAPTERS: TutorialChapterDef[] = [...SETUP_CHAPTERS, ...DAY_CHAPTERS];
